<template><section><h3>Stack Popup Example</h3>
<p><strong>Script</strong></p>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">import</span> ComponentStack <span class="hljs-keyword">from</span> <span class="hljs-string">'@/components/Demo/CustomComponent/ComponentStack.vue'</span>
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">methods</span>: {
    popup() {
      <span class="hljs-keyword">this</span>.$popup(<span class="hljs-string">'append'</span>, {
        <span class="hljs-attr">component</span>: ComponentStack,
      })
    },
  },
}
</code></pre>
<p><strong>ComponentStack.vue</strong></p>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">:style</span>=<span class="hljs-string">"{ width: level*20+'vw'}"</span> <span class="hljs-attr">foobar</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">h4</span>&gt;</span>foobar level{{level}}<span class="hljs-tag">&lt;/<span class="hljs-name">h4</span>&gt;</span>

    <span class="hljs-tag">&lt;<span class="hljs-name">button</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"btn btn-sm btn-dark"</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"popup"</span>&gt;</span>
      popup
    <span class="hljs-tag">&lt;/<span class="hljs-name">button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span> <span class="hljs-attr">lang</span>=<span class="hljs-string">"babel"</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"text/babel"</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">import</span> ComponentStack <span class="hljs-keyword">from</span> <span class="hljs-string">'@/components/Demo/CustomComponent/ComponentStack.vue'</span>
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">props</span>: {
    <span class="hljs-attr">popupConfig</span>: {
      <span class="hljs-attr">type</span>: <span class="hljs-built_in">Object</span>,
    },
  },
  <span class="hljs-attr">methods</span>: {
    popup() {
      <span class="hljs-keyword">this</span>.$popup(<span class="hljs-string">'append'</span>, {
        <span class="hljs-attr">component</span>: ComponentStack,
        <span class="hljs-attr">level</span>: <span class="hljs-keyword">this</span>.level+<span class="hljs-number">1</span>
      })
    },
  },
  <span class="hljs-attr">computed</span>: {
    level() {
      <span class="hljs-keyword">if</span>(!<span class="hljs-keyword">this</span>.popupConfig.level) <span class="hljs-keyword">return</span> <span class="hljs-number">1</span>
      <span class="hljs-keyword">return</span> <span class="hljs-keyword">this</span>.popupConfig.level
    },
  },
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
</section></template>

<script lang="babel" type="text/babel">
import ComponentStack from '@/components/Demo/CustomComponent/ComponentStack.vue'
export default {
  props: {
    popupConfig: {
      type: Object,
    },
  },
  methods: {
    popup() {
      this.$popup('append', {
        component: ComponentStack,
        level: this.level+1
      })
    },
  },
  computed: {
    level() {
      if(!this.popupConfig.level) return 1
      return this.popupConfig.level
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Demo/CustomComponent/ExampleStack.vue